/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
export class EventContext {
  constructor(contextId) {
    this.contextId = contextId;
  }
}